<template>
    <div>
        <span class="mailbox-read-time pull-right" v-if="!isRead">
            <a href="#" @click="markAsRead()">{{ markAsReadString }}</a>
        </span>
    </div>
</template>

<script>
    import { EventBus } from "../../../eventBus";

    export default {
        props: ['latestNotification', 'readRoute', 'markAsReadString', 'read'],
        data: function () {
            return {
                isRead: this.read,
            }
        },
        methods: {
            markAsRead() {
                axios.post(this.readRoute, {})
                    .then((res)=> {
                        this.isRead = true;
                        EventBus.emit('notificationRead', { unreadNotificationsCount: res.data.unreadNotificationsCount, notificationId: res.data.notificationId, infoMessage: res.data.infoMessage });
                    });
            }
        }
    }
</script>